import script from "./McpAccessDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./McpAccessDrawer.vue?vue&type=script&setup=true&lang=js"

import "./McpAccessDrawer.vue?vue&type=style&index=0&id=0f9dc304&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9dc304"]])

export default __exports__